/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserProfileSchema } from './UserProfileSchema';
import {
    UserProfileSchemaFromJSON,
    UserProfileSchemaFromJSONTyped,
    UserProfileSchemaToJSON,
} from './UserProfileSchema';

/**
 * 
 * @export
 * @interface UserLightSchema
 */
export interface UserLightSchema {
    /**
     * 
     * @type {number}
     * @memberof UserLightSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserLightSchema
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserLightSchema
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserLightSchema
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserLightSchema
     */
    email: string;
    /**
     * 
     * @type {UserProfileSchema}
     * @memberof UserLightSchema
     */
    profile: UserProfileSchema;
}

/**
 * Check if a given object implements the UserLightSchema interface.
 */
export function instanceOfUserLightSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "fullName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "profile" in value;

    return isInstance;
}

export function UserLightSchemaFromJSON(json: any): UserLightSchema {
    return UserLightSchemaFromJSONTyped(json, false);
}

export function UserLightSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLightSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'fullName': json['full_name'],
        'preferredName': !exists(json, 'preferred_name') ? undefined : json['preferred_name'],
        'email': json['email'],
        'profile': UserProfileSchemaFromJSON(json['profile']),
    };
}

export function UserLightSchemaToJSON(value?: UserLightSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'username': value.username,
        'full_name': value.fullName,
        'preferred_name': value.preferredName,
        'email': value.email,
        'profile': UserProfileSchemaToJSON(value.profile),
    };
}

